var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#menu-burger_svg__clip0_2729_53820)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.042 10.541H.958a.958.958 0 100 1.917h21.084a.958.958 0 000-1.917zM22.042 3.834H.958a.958.958 0 100 1.916h21.084a.958.958 0 000-1.916zM22.042 17.25H.958a.958.958 0 000 1.917h21.084a.958.958 0 000-1.917z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-burger_svg__clip0_2729_53820"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h23v23H0z"
  })))));
};

export default SvgMenuBurger;